import store from "@/store/index";
import * as config from "../utils/config";

export default function checkLogin({ to, from, next }) {
  const isUserLoggedIn = localStorage.getItem(config.USER);
  return isUserLoggedIn ? next({ name: "home" }) : next();
}
